import React from 'react';

import { Email as EmailIcon, Phone as PhoneIcon } from '@mui/icons-material';
import { Box, Link, Paper, Typography } from '@mui/material';

import { SUPPORT_CLEARVERIFY_EMAIL } from '@clearverify/constants';

import { PageLayout } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';

import { IconSx, LinkSx, mobileContentWrapperStyles, pageLayoutPaperSx, paperSx } from './styles';

export const ResourcesLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isMobile } = useScreenInfo();

  if (isMobile) {
    return <Box sx={mobileContentWrapperStyles}>{children}</Box>;
  }

  return (
    <PageLayout
      topRightContent={
        <Box flexDirection="row" display="flex">
          <Box marginLeft="10px">
            <Paper elevation={0} variant="elevation" sx={paperSx}>
              <PhoneIcon color="action" fontSize="large" sx={IconSx} />
              <div>
                <Typography fontWeight={500}>Contact Us</Typography>
                <Link sx={LinkSx} href="tel:888-990-7071">
                  <Typography color="primary.main">(888) 990-7071</Typography>
                </Link>
              </div>
            </Paper>
          </Box>
          <Box alignItems="center" marginLeft="10px">
            <Paper elevation={0} variant="elevation" sx={paperSx}>
              <EmailIcon color="action" fontSize="large" sx={IconSx} />
              <div>
                <Typography fontWeight={500}>Email Us</Typography>
                <Link sx={LinkSx} href={`mailto:${SUPPORT_CLEARVERIFY_EMAIL}`}>
                  <Typography color="primary.main">{SUPPORT_CLEARVERIFY_EMAIL}</Typography>
                </Link>
              </div>
            </Paper>
          </Box>
        </Box>
      }
      titleContent="Resources"
      paperSx={pageLayoutPaperSx}
    >
      {children}
    </PageLayout>
  );
};
